import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tabs" }

import { ProjectStore } from "../store/ProjectStore";
import { nextTick, onMounted } from "vue";

export type TabsProps = {
  tabName1: string;
  tabName2: string;
  tabName3: string;
  applied: number;
  progress: number;
  completed: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    tabName1: {},
    tabName2: {},
    tabName3: {},
    applied: {},
    progress: {},
    completed: {}
  },
  emits: ["tabchange"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const omistore = ProjectStore();
const emit = __emit;

onMounted(async () => {
  tabChange(omistore.selectedStatus);
  await nextTick()
  const elements = document.getElementsByName(
    "tab_item"
  ) as NodeListOf<HTMLInputElement>;
  elements[omistore.selectedStatus - 1].checked = true;
});


// APIを公開
__expose({
  tabChange,
});

function tabChange(tabId: number) {
  emit("tabchange", tabId);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("input", {
      id: "applied",
      type: "radio",
      name: "tab_item",
      checked: ""
    }, null, -1 /* HOISTED */)),
    _createElementVNode("label", {
      class: "applied tab_item",
      for: "applied",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (tabChange(1)))
    }, [
      _withDirectives(_createElementVNode("span", {
        class: "new",
        style: _normalizeStyle([_ctx.applied > 9 ? 'width: 20px;' : 'width: 16px;'])
      }, _toDisplayString(_ctx.applied), 5 /* TEXT, STYLE */), [
        [_vShow, _ctx.applied > 0 && _ctx.tabName1]
      ]),
      _createTextVNode(_toDisplayString(_ctx.tabName1), 1 /* TEXT */)
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("input", {
      id: "in-progress",
      type: "radio",
      name: "tab_item"
    }, null, -1 /* HOISTED */)),
    _createElementVNode("label", {
      class: "in-progress tab_item",
      for: "in-progress",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (tabChange(2)))
    }, [
      _withDirectives(_createElementVNode("span", {
        class: "new",
        style: _normalizeStyle([_ctx.progress > 9 ? 'width: 20px;' : 'width: 16px;'])
      }, _toDisplayString(_ctx.progress), 5 /* TEXT, STYLE */), [
        [_vShow, _ctx.progress > 0 && _ctx.tabName2]
      ]),
      _createTextVNode(_toDisplayString(_ctx.tabName2), 1 /* TEXT */)
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("input", {
      id: "deliverd",
      type: "radio",
      name: "tab_item"
    }, null, -1 /* HOISTED */)),
    _createElementVNode("label", {
      class: "deliverd tab_item",
      for: "deliverd",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (tabChange(3)))
    }, [
      _withDirectives(_createElementVNode("span", {
        class: "new",
        style: _normalizeStyle([_ctx.completed > 9 ? 'width: 20px;' : 'width: 16px;'])
      }, _toDisplayString(_ctx.completed), 5 /* TEXT, STYLE */), [
        [_vShow, _ctx.completed > 0 && _ctx.tabName3]
      ]),
      _createTextVNode(_toDisplayString(_ctx.tabName3), 1 /* TEXT */)
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("span", { id: "slider" }, null, -1 /* HOISTED */))
  ]))
}
}

})